import React from 'react';

import { FlexLayout } from 'ui/components/styled';
import { LoadingOverlay } from 'ui/components/shared';
import { useLayout, useToasts, useSlowUpdate } from 'hooks';

export const AuthLayout = ({ children, show = true, ...props }) => {
  const { isLoading, setLayoutLoading } = useLayout();
  const { removeAllToasts } = useToasts();
  const loading = useSlowUpdate(isLoading, () => isLoading === false, 300);

  React.useEffect(() => {
    return () => {
      removeAllToasts();
      setLayoutLoading(false);
    };
  }, []);

  return (
    show && (
      <FlexLayout bg="#F5F9FF" {...props}>
        {loading && <LoadingOverlay></LoadingOverlay>}
        {children}
      </FlexLayout>
    )
  );
};
